import React from "react";
import Chart from 'react-apexcharts';
import { setChartColors } from "modules/reporting/utils/chartConfig";


export default function BarChartComponent({
    payload, chartHeight, chartColors = [], stacked, dontAddUnknown = true, translate
}) {
    const options = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: stacked,
        },
        dataLabels: {
            enabled: false
        },
        markers: {
            size: 4
        },
        plotOptions: {
            bar: {
                horizontal: false,
            }
        },
        stroke: {
            show: true,
            curve: "straight",
            lineCap: "butt",
            width: 2,
        },
        xaxis: {
            categories: payload.labels,
            tickPlacement: 'between',
            labels: {
                hideOverlappingLabels: true,
            }
        },
        fill: {
            opacity: 1
        },
        legend: {
            position: 'bottom',
            itemMargin: {
                horizontal: 20,
                vertical: 16
            }
        },
        colors: chartColors.length > 0 ? chartColors : setChartColors(payload.datasets.length, dontAddUnknown),
    }

    const chartSeries = () => {
        let series = JSON.stringify(payload);
        series = JSON.parse(series);

        series.datasets.forEach(e => {
            e.name = translate(e.name);
        });

        return series;
    }
    return (
        <Chart
            series={
                chartSeries().datasets
            }

            options={
                options
            }

            type="bar"
            height={chartHeight ?? 'auto'}
        >

        </Chart>
    )
} 